export const TOKEN_KEY = "ebs-client-token";
export const AUTOMATIC_BILLNO = "ebs-automatic-billno";
export const CALENDAR_TYPE = "ebs-calendar-type";
export const CALENDAR_LANG = "ebs-calendar-language";
export const PAID_AMOUNT = "ebs-paid-amount";
export const APP_LOCALIZATION = "ebs-app-localization";
export const USER_DETAILS = "ebs-user-details";
export const PERMISSIONS = "ebs-permissions";
export const JOURNAL_VIEW_TYPE = "ebs-journal-view-type";
export const AMOUNT_TYPE = "ebs-amount-type";
export const FORCE_REFRESH_LIMIT = "ebs-force-refresh-limit";
